import { useMemo } from 'react';
import { getSidebarServiceLinks } from '@frontend/config/serviceLinkRegistry';
import { usePublicIntegration } from '../../../../context/PublicIntegrationContext';

export default function ServiceNavSection() {
  const appOrigin = typeof window === 'undefined' ? '' : window.location.origin;
  const integration = usePublicIntegration();
  const links = useMemo(() => getSidebarServiceLinks(appOrigin, integration), [appOrigin, integration]);

  return (
    <div className="tree-dashboard-sidebar-section">
      <div className="tree-dashboard-sidebar-title">Service Navigation</div>
      <div className="tree-dashboard-quick-links">
        {links.map((link) => (
          <a key={link.id} className="tree-dashboard-quick-link" href={link.href} target="_blank" rel="noopener noreferrer">
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
}
